import './fileDropArea.scss';

import { FC, memo } from 'react';
import bemFactory from 'react-bem-factory';

import { messages } from './FileDropArea.messages';
import FileDropProvider from './FileDropProvider';

const bem = bemFactory.block('reqf-file-drop-area');
const qa = bemFactory.qa('reqf-file-drop-area');

interface FileDropAreaProps {
    className?: string;
}

/**
 * @deprecated Use AttachmentsSection
 */
const FileDropArea: FC<FileDropAreaProps> = (props) => {
    const { className } = props;

    return (
        <FileDropProvider.Consumer>
            {({ isActive }) => (
                <div data-qa={qa()} className={bem.add(className)(null, { active: isActive })}>
                    <div className={bem('content')}>{messages.dropHereText}</div>
                </div>
            )}
        </FileDropProvider.Consumer>
    );
};

export default memo(FileDropArea);
